import "../css/editor.css";

(function (wp) {
  const { addFilter } = wp.hooks;
  const { Fragment } = wp.element;
  const { InspectorControls } = wp.blockEditor;
  const { PanelBody, TextControl, SelectControl, ToggleControl } =
    wp.components;
  const { createHigherOrderComponent } = wp.compose;
  const { __ } = wp.i18n;

  // PHPから渡された言語リストを取得
  const languages = window.synanoLanguages || [
    { label: __("Auto Detect", "syntax-highlight-nano"), value: "auto" },
  ];

  /**
   * カスタム属性を追加
   */
  function addAttributes(settings, name) {
    if (name !== "core/code") {
      return settings;
    }

    // PHPから渡されたデフォルト設定を取得
    const defaultOptions = window.synanoDefaults || {
      default_language: "auto",
      default_show_header: true,
      default_show_line_numbers: false,
    };

    return {
      ...settings,
      attributes: {
        ...settings.attributes,
        language: {
          type: "string",
          default: defaultOptions.default_language || "auto",
        },
        filename: {
          type: "string",
          default: "",
        },
        showHeader: {
          type: "boolean",
        },
        showLineNumbers: {
          type: "boolean",
        },
      },
    };
  }

  addFilter("blocks.registerBlockType", "synano/add-attributes", addAttributes);

  /**
   * インスペクターコントロールを追加
   */
  const withInspectorControls = createHigherOrderComponent((BlockEdit) => {
    return (props) => {
      if (props.name !== "core/code") {
        return <BlockEdit {...props} />;
      }

      const { attributes, setAttributes, clientId } = props;
      const {
        language = "",
        filename = "",
        showHeader,
        showLineNumbers,
      } = attributes;

      // 初回のみ属性を初期化（未定義の場合のみ）
      wp.element.useEffect(() => {
        const defaults = window.synanoDefaults || {
          default_language: "auto",
          default_show_header: true,
          default_show_line_numbers: false,
        };
        const updates = {};
        if (!("showHeader" in attributes)) {
          updates.showHeader = !!defaults.default_show_header;
        }
        if (!("showLineNumbers" in attributes)) {
          updates.showLineNumbers = !!defaults.default_show_line_numbers;
        }
        if (Object.keys(updates).length) {
          setAttributes(updates);
        }
      }, [clientId]);

      return (
        <Fragment>
          <BlockEdit {...props} />
          <InspectorControls>
            <PanelBody
              title={__("Syntax Highlight Settings", "syntax-highlight-nano")}
              initialOpen={true}
            >
              <SelectControl
                label={__("Language", "syntax-highlight-nano")}
                value={language}
                options={languages}
                onChange={(value) => setAttributes({ language: value })}
                help={__(
                  "Select the language of your code. Auto will detect automatically.",
                  "syntax-highlight-nano"
                )}
              />
              <TextControl
                label={__("Filename", "syntax-highlight-nano")}
                value={filename}
                onChange={(value) => setAttributes({ filename: value })}
                help={__(
                  "If set, the filename will be shown in the header.",
                  "syntax-highlight-nano"
                )}
                placeholder="e.g. example.js"
              />
              <ToggleControl
                label={__("Show Header", "syntax-highlight-nano")}
                checked={!!showHeader}
                onChange={(value) => setAttributes({ showHeader: value })}
                help={__(
                  "Display filename or language name.",
                  "syntax-highlight-nano"
                )}
              />
              <ToggleControl
                label={__("Show Line Numbers", "syntax-highlight-nano")}
                checked={!!showLineNumbers}
                onChange={(value) => setAttributes({ showLineNumbers: value })}
              />
            </PanelBody>
          </InspectorControls>
        </Fragment>
      );
    };
  }, "withInspectorControls");

  addFilter(
    "editor.BlockEdit",
    "synano/with-inspector-controls",
    withInspectorControls
  );

  /**
   * ブロックに追加のクラス名を設定
   */
  const withExtraClassName = createHigherOrderComponent((BlockListBlock) => {
    return (props) => {
      if (props.name !== "core/code") {
        return <BlockListBlock {...props} />;
      }

      const { attributes } = props;
      const {
        language = "",
        filename = "",
        showHeader,
        showLineNumbers,
      } = attributes;

      // カスタムクラスを追加
      const extraClasses = ["synano"];

      const newClassName = `${props.className || ""} ${extraClasses.join(" ")}`;

      // data属性でメタ情報を追加
      const wrapperProps = {
        ...props.wrapperProps,
        "data-language": language,
        "data-filename": filename,
        "data-show-header": !!showHeader,
        "data-show-line-numbers": !!showLineNumbers,
      };

      return (
        <BlockListBlock
          {...props}
          className={newClassName}
          wrapperProps={wrapperProps}
        />
      );
    };
  }, "withExtraClassName");

  addFilter(
    "editor.BlockListBlock",
    "synano/with-extra-classname",
    withExtraClassName
  );
})(window.wp);
